export const NET_PARTNER = "10046";
export const NET_PARTNER_KEY = "*&^afa1141";



// WEBPACK FOOTER //
// ./src/assets/js/requestConfig.js